<template class="full-height">
  <!-- $t is vue-i18n global function to translate lang -->
  <div class="coupon-container full-height">
    <el-dialog
      @closed="onDialogClosed"
      top="2%"
      width="80%"
      :visible.sync="dialogFormVisible"
      :title="'優惠票券維護'"
      @open="clearFiles"
    >
      <coupon-data
        ref="couponDataRef"
        :categories="categories"
        :formData="formData"
        :fatherDialogFormVisible="fatherDialogFormVisible"
        :saveSuccess="saveSuccess"
      ></coupon-data>
    </el-dialog>

    <!-- <el-form :inline="true">
        <el-form-item label="查詢">
          <el-input v-model="listQuery.qry" placeholder="輸入票券名稱" />
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="getList" :disabled="listLoading"
            >查詢</el-button
          >
          <el-button type="success" @click="addData" :disabled="listLoading"
            >建立</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-button
            :loading="listLoading"
            type="success"
            icon="el-icon-refresh-left"
            circle
            @click="refresh"
          ></el-button>
        </el-form-item>
      </el-form> -->

    <el-form :inline="true" class="filter-form" @submit.native.prevent>
      <el-form-item label="查詢">
        <el-input
          v-model="listQuery.qry"
          placeholder="輸入票券名稱"
          @keyup.enter.native="getList"
        />
      </el-form-item>

      <el-button
        type="primary"
        @click="getList"
        icon="el-icon-search"
        circle
        style="margin-top: 8px; margin-left: 5px"
        :disabled="listLoading"
      ></el-button>
      <el-button
        type="warning"
        @click="addData"
        circle
        icon="el-icon-plus"
        :disabled="listLoading"
      ></el-button>
      <el-button
        style="cursor: pointer"
        type="success"
        :loading="listLoading"
        circle
        icon="el-icon-refresh-left"
        @click="refresh()"
      ></el-button>
      <!-- 推播歷史紀錄 -->
      <NotificationHistory class="notification-history" />
    </el-form>

    <el-alert
      style="background-color: #ffd643; color: #4b4b4b; margin-bottom: 10px"
      :closable="false"
      title="排序可設定小數點，數字越小會排在前面"
      type="info"
      effect="dark"
    >
    </el-alert>
    <div style="position: relative; height: 73%">
      <el-table
        v-loading="listLoading"
        size="mini"
        :data="list"
        border
        fit
        highlight-current-row
        height="100%"
      >
        <el-table-column align="center" label="項次" width="60">
          <template slot-scope="scope">
            <span
              :style="{
                color: new Date() > new Date(scope.row.endDate) ? 'gray' : 'inherit',
                textDecoration: new Date() > new Date(scope.row.endDate) ? 'line-through' : 'none',
              }"
            >
              {{ scope.$index + 1 }}
            </span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="票券名稱" width="200">
          <template slot-scope="scope">
            <span
              :style="{
                color: new Date() > new Date(scope.row.endDate) ? 'gray' : 'inherit',
                textDecoration: new Date() > new Date(scope.row.endDate) ? 'line-through' : 'none',
              }"
            >
              {{ scope.row.couponName }}
            </span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="開放日期" width="180">
          <template slot-scope="scope">
            <span
              :style="{
                color: new Date() > new Date(scope.row.endDate) ? 'gray' : 'inherit',
                textDecoration: new Date() > new Date(scope.row.endDate) ? 'line-through' : 'none',
              }"
            >
              {{ scope.row.beginDate }} 至 {{ scope.row.endDate }}
            </span>
          </template>
        </el-table-column>

        <el-table-column
          align="center"
          label="票券地點"
          v-if="checkPermission(['ITA-DEV', 'APP-ADMIN', 'ITA-ADMIN'])"
        >
          <template slot-scope="scope">
            <span
              :style="{
                color: new Date() > new Date(scope.row.endDate) ? 'gray' : 'inherit',
                textDecoration: new Date() > new Date(scope.row.endDate) ? 'line-through' : 'none',
              }"
            >
              {{ scope.row.position }}
            </span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="排序" width="60">
          <template slot-scope="scope">
            <span
              :style="{
                color: new Date() > new Date(scope.row.endDate) ? 'gray' : 'inherit',
                textDecoration: new Date() > new Date(scope.row.endDate) ? 'line-through' : 'none',
              }"
            >
              {{ scope.row.sort }}
            </span>
          </template>
        </el-table-column>

        <el-table-column
          align="center"
          label="旅行社"
          v-if="checkPermission(['ITA-DEV', 'APP-ADMIN', 'ITA-ADMIN', 'ITA-ADM-STAFF'])"
        >
          <template slot-scope="scope">
            <el-tag v-if="scope.row.agencyTravelInfo.agencyName">{{
              scope.row.agencyTravelInfo.agencyName
            }}</el-tag>
          </template>
        </el-table-column>
        <!-- 
        <el-table-column align="center" label="旅遊團數量" width="120">
          <template slot-scope="scope">
            <el-tooltip
              v-if="
                scope.row.agencyTravelInfo.travelNames &&
                scope.row.agencyTravelInfo.travelNames.length > 0
              "
              class="item"
              effect="dark"
              placement="right"
            >
          
             <template #content> {{ listDisplayTravelsName(scope.row.agencyTravelInfo.travelNames)}} </template>
              <el-tag>{{
                scope.row.agencyTravelInfo.travelNames.length
              }}</el-tag>
            </el-tooltip>
          </template>
        </el-table-column> -->

        <el-table-column align="center" label="設為問卷使用" width="120">
          <template slot-scope="scope">
            <i
              v-if="scope.row.showToSurvey"
              class="el-icon-star-on"
              style="font-size: 18px; color: #ff6d6d"
            />
          </template>
        </el-table-column>

        <el-table-column align="center" label="編輯" width="120">
          <template slot-scope="scope">
            <el-button
              type="success"
              @click="editData(scope.row)"
              size="mini"
              :style="{
                backgroundColor: new Date() > new Date(scope.row.endDate) ? 'gray' : '',
                borderColor: new Date() > new Date(scope.row.endDate) ? 'gray' : '#13ce66',
              }"
            >
              {{ new Date() > new Date(scope.row.endDate) ? '查看' : '編輯' }}
            </el-button>
          </template>
        </el-table-column>

        <el-table-column align="center" label="刪除" width="120">
          <template slot-scope="scope">
            <el-button type="danger" @click="deleteData(scope.row)" size="mini">刪除</el-button>
          </template>
        </el-table-column>
        <el-table-column align="center" label="發送推播" width="120">
          <template slot-scope="scope">
            <NotificationSetting :data="scope.row" />
          </template>
        </el-table-column>
      </el-table>
    </div>
    <pagination
      v-show="total > 0"
      layout="prev, pager, next"
      :total="total"
      :page.sync="listQuery.page"
      :limit.sync="listQuery.limit"
      @pagination="getList"
    />
  </div>
</template>

<script>
import Pagination from '@/components/Pagination' // Secondary package based on el-pagination
import {
  getCoupons,
  deleteCoupon,
  getCouponLoopCategoryOptions,
  saveDefaultCoupon,
  getDefaultCoupon,
} from '@/api/coupon'
import { MessageBox, Message } from 'element-ui'
import Upload from '@/views/ita/components/fileUpload.vue'
import CouponData from '@/views/ita/appManage/components/couponData.vue'
import NotificationHistory from '@/views/ita/appManage/components/notificationHistory.vue'
import NotificationSetting from '@/views/ita/appManage/components/notificationSetting.vue'
import checkPermission from '@/utils/permission' // 权限判断函数

import { getAgencyCouponsOption } from '@/api/travel'

var defaultForm = {
  id: null,
  couponPhone: null,
  couponName: null,
  title: null,
  position: null,
  description: null,
  link: null,
  sort: null,
  couponCategories: [{ sort: 1, selected: null }],
  fileInfo: {},
  beginDate: '',
  endDate: '',
  dateRange: [new Date(), new Date()],
}

export default {
  name: 'CouponDataList',
  components: {
    Pagination,
    Upload,
    CouponData,
    NotificationSetting,
    NotificationHistory,
  },
  data() {
    return {
      agencyCode: null,
      defaultCoupon: {},
      groupCoupons: [],
      categories: [],
      formData: defaultForm,
      dialogFormVisible: false,
      listLoading: false,
      listQuery: {
        qry: '',
        date: '',
        status: null,
        page: 1,
        limit: 20,
        sort: '-id',
        agencyCode: null,
      },
      total: 0,
      list: [],
    }
  },
  async created() {
    this.agencyCode = this.$store.getters.userInfo.agencyCode
      ? this.$store.getters.userInfo.agencyCode
      : null
    await this.getAgencyCouponsOption()
    await this.getCategories()
    await this.getList()
  },
  methods: {
    checkPermission,
    async refresh() {
      this.listQuery = {
        qry: '',
        date: '',
        status: null,
        page: 1,
        limit: 20,
        sort: '-id',
        agencyCode: null,
      }
      await this.getList()
    },
    async getDefaultCoupon() {
      let vm = this
      if (!vm.agencyCode) {
        // alert(`未取得旅行社代碼，無法取得預設票券。`);
        vm.defaultCoupon = null

        return false
      }
      let resp = await getDefaultCoupon({ agencyCode: vm.agencyCode })
      vm.defaultCoupon = resp.data
    },
    async setDefault() {
      let vm = this
      if (!vm.defaultCoupon) {
        alert('未選擇票券')
        return false
      }
      vm.defaultCoupon.isDefault = true
      vm.defaultCoupon.agencyTravelInfo.agencyCode = vm.agencyCode
      if (!vm.defaultCoupon.agencyTravelInfo.agencyCode) {
        alert(`未取得旅行社代碼，無法設定預設票券。`)
        return false
      }
      vm.listLoading = true
      let resp = await saveDefaultCoupon(vm.defaultCoupon)
      await this.getList()
      vm.listLoading = false
      this.$message({
        message: '預設票券處理完成',
        type: 'success',
      })
    },
    async getAgencyCouponsOption() {
      this.listLoading = true
      let resp = await getAgencyCouponsOption({ agencyCode: this.agencyCode })
      this.groupCoupons = resp.data
      this.listLoading = false
    },
    async getCategories() {
      let vm = this
      this.listLoading = true

      let resp = await getCouponLoopCategoryOptions({
        agencyCode: vm.agencyCode,
      })
      vm.categories = resp.data
      this.listLoading = false
    },
    listDisplayTravelsName(list) {
      return list.join('，')
    },
    fatherDialogFormVisible(action) {
      let vm = this
      vm.dialogFormVisible = action
    },
    async deleteData(row) {
      if (row.id && confirm(`確定刪除此票券?`)) {
        this.listLoading = true
        let res = await deleteCoupon({ key: row.id })
        this.listLoading = false
        await this.getList()
        this.$message({
          message: '資料處理完成',
          type: 'success',
        })
      }
    },
    async getList() {
      this.listLoading = true
      this.listQuery.agencyCode = this.agencyCode
      let res = await getCoupons(this.listQuery)
      this.list = res.data.data
      this.total = res.data.total
      console.log('this.total', this.total)
      await this.getDefaultCoupon()
      this.listLoading = false
    },
    addData() {
      let vm = this
      vm.formData = JSON.parse(JSON.stringify(defaultForm))
      vm.dialogFormVisible = true
    },
    editData(row) {
      let vm = this
      //為了要觸發Upload的watch beforeFileList
      vm.formData.fileInfo = []
      vm.formData = JSON.parse(JSON.stringify(row))
      vm.formData.dateRange = [vm.formData.beginDate, vm.formData.endDate]
      console.log(vm.formData)
      vm.dialogFormVisible = true
    },
    onDialogClosed() {
      // this.clearFiles();
    },
    async saveSuccess() {
      let vm = this
      await vm.getList()
      await this.getAgencyCouponsOption()
    },
    clearFiles() {
      let refCoupon = this.$refs['couponDataRef']
      if (refCoupon) {
        refCoupon.clearFiles()
      }
    },
  },
}
</script>

<style>
.full-height {
  position: relative;
  height: 100%;
}
.el-dialog__body {
  padding: 15px;
}

.option_box {
  display: flex;
  align-items: center;
}

.option_img {
  width: 25px;
  height: 25px;
  margin-right: 7px;
}
</style>
<style scoped>
.notification-history {
  display: inline-block;
  margin-left: 10px;
}
</style>
